export default {"src":"/_next/static/media/girl-careful.4b56681e.svg","height":536,"width":411,"blurWidth":0,"blurHeight":0};